import gql from 'graphql-tag'

export const FullNewsFragment = gql`
  fragment FullNewsFragment on News {
    id
    stage
    linkUrl
    publicationDate
    headline
    text
    linkLabel
    teaserImage {
      handle
      fileName
      width
      height
      url
      mimeType
    }
  }
`

export default gql`
  query News(
    $lang: [Locale!]!
    $now: DateTime!
    $lastRead: DateTime
    $first: Int
    $skip: Int
    $stage: Stage!
  ) {
    newses(
      where: { publicationDate_lte: $now }
      orderBy: publicationDate_DESC
      first: $first
      skip: $skip
      locales: $lang
      stage: $stage
    ) {
      ...FullNewsFragment
    }
    unreadNews: newsesConnection(
      where: {
        AND: [{ publicationDate_gt: $lastRead }, { publicationDate_lte: $now }]
      }
      stage: $stage
      locales: $lang
    ) {
      aggregate {
        count
      }
    }
    totalNews: newsesConnection(
      where: { publicationDate_lte: $now }
      stage: $stage
      locales: $lang
    ) {
      aggregate {
        count
      }
    }
  }
  ${FullNewsFragment}
`



// WEBPACK FOOTER //
// ./src/queries/news.js